import Footer from "../../components/Footer";
import LanImg_2 from "../../assets/img/ourStory.png";
import LanIcon_3 from "../../assets/img/Black.png";
import "../style.css";
import { useParams } from "react-router-dom";
import LanImg_1 from "../../assets/img/ptte.png";
import LanguageLearnMore from "./LanguageLearnMore";
export default function PTE() {
  const { id } = useParams();
  const learnMoreData = {
    pageName: "PTE",
    heroSection: {
      header1: "PTE for",
      header2: "university entry",
      desc: "PTE Academic is the only fully computer-based English language test for international study and migration.",
      rightImg: LanImg_1,
    },
    aboutTestSection: {
      img: LanImg_2,
      header: "What is PTE?",
      desc1:
        "The Pearson Test of English (PTE) is a fully computer-based English language proficiency test accepted by universities, colleges, and governments worldwide. The test evaluates your skills in writing, reading, listening, and speaking using a combination of human expertise and AI tools for accurate and non-biased scoring.",
      desc2:
        "You can book your test 24 hours in advance and typically receive the results within 48 hours of completing the test, making it a convenient option for many international students.",
    },
    blueCardSection: {},
    differenceSection: {
      header: "What makes PTE different?",
      desc: "PTE tests stand out as you can book quickly, receive your scores within 48 hours, and easily share them with universities as a fully digital score report.",
      cards: [
        {
          img: LanIcon_3,
          header: "Fast and non-biased scoring",
          desc: "PTE uses AI scoring to reduce the risk of bias and deliver results faster",
        },
        {
          img: LanIcon_3,
          header: "Only one test",
          desc: "You only need to complete a single two-hour test",
        },
        {
          img: LanIcon_3,
          header: "No human examiners",
          desc: "The test is fully computer-based, so you don’t need to face human examiners",
        },
        {
          img: LanIcon_3,
          header: "Free score sharing",
          desc: "You can share your Score Report with as many institutions as you want at no additional cost",
        },
      ],
    },
    scoreSection: {
      header: "Guide to PTE Scoring",
      desc: "PTE Academic (including UKVI) and PTE Core tests are scored from 10–90. While requirements vary by university and course, these are the typical minimum scores:",
      cards: [
        {
          img: LanIcon_3,
          header: "Foundation",
          desc: "Minimum score between 36–50",
        },
        {
          img: LanIcon_3,
          header: "Undergraduate",
          desc: "Minimum score between 51–60",
        },
        {
          img: LanIcon_3,
          header: "Postgraduate",
          desc: "Minimum score between 57–67",
        },
      ],
    },
    testFormatSection: {
      header: "Password Skills Plus test format",
      desc: "The Password Skills Plus test consists of four test modules – reading, writing, listening and speaking. It takes three hours and five minutes to complete.",
      tableData: {
        rowHeader: ["Module", "Who can apply", "Description"],
        rowData: [
          {
            column1: "Password Reading",
            column2: "One hour and 15 minutes",
            column3:
              "Password Reading has five sections. Each section contains one task such as answering multiple-choice questions and reordering sentences to form a coherent paragraph.",
          },
          {
            column1: "Password Writing",
            column2: "30 minutes",
            column3:
              "Password Writing assesses your ability to write an essay. You have a choice of two essay titles to write an essay of at least 200 words.",
          },

          {
            column1: "Password Listening",
            column2: "One hour",
            column3:
              "Password Listening has five sections. In each section, you have to listen to multiple recordings and answer questions based on their contents. Once you press play, the recording cannot be paused or restarted. Each recording plays twice and questions appear on the second playback.",
          },
          {
            column1: "Password Listening",
            column2: "One hour",
            column3:
              "Password Listening has five sections. In each section, you have to listen to multiple recordings and answer questions based on their contents. Once you press play, the recording cannot be paused or restarted. Each recording plays twice and questions appear on the second playback.",
          },
        ],
      },
    },
  };

  return (
    <div className="pte">
     
      <LanguageLearnMore learnMoreData={learnMoreData} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
